import type { SentimentClassification } from "./sentimentApi";

export type SentimentTone = "good" | "average" | "poor" | "idle";

export interface SentimentPresentation {
  tone: SentimentTone;
  shortLabel: string;
  description: string;
  classification: SentimentClassification | null;
}

export const EMPTY_SENTIMENT_PRESENTATION: SentimentPresentation = {
  tone: "idle",
  shortLabel: "",
  description: "",
  classification: null,
};

export function presentationFromSentiment(input: {
  classification?: string | null;
  shortLabel?: string | null;
  description?: string | null;
}): SentimentPresentation {
  const classification = normalizeClassification(input.classification);
  if (!classification) {
    return EMPTY_SENTIMENT_PRESENTATION;
  }

  const tone = toneForClassification(classification);
  return {
    tone,
    shortLabel: input.shortLabel?.trim() || shortLabelForClassification(classification),
    description:
      input.description?.trim() ||
      `Customer tone appears ${classification.toLowerCase()}.`,
    classification,
  };
}

export function normalizeClassification(
  value?: string | null
): SentimentClassification | null {
  if (!value?.trim()) return null;
  const normalized = value.trim().toLowerCase();
  if (normalized.startsWith("pos")) return "Positive";
  if (normalized.startsWith("neg")) return "Negative";
  if (normalized.startsWith("neu")) return "Neutral";
  return null;
}

export function toneForClassification(
  classification: SentimentClassification
): SentimentTone {
  switch (classification) {
    case "Positive":
      return "good";
    case "Negative":
      return "poor";
    default:
      return "average";
  }
}

export function shortLabelForClassification(
  classification: SentimentClassification
): string {
  switch (classification) {
    case "Positive":
      return "Good";
    case "Negative":
      return "Poor";
    default:
      return "Average";
  }
}
